module.exports = __webpack_public_path__ + "static/media/CloudDisk_001.b8d206bb.png";